module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing_jp.b8865f95a7dc9de4eb0dfe6a94eac5a0.png";